import { useIsFeatureEnabled } from "@nens/ranalib";

import { useTenantActionAllowed } from "./use-action-allowed-in-tenant";

// This hook and the checks that are used by it can be removed after all the child tickets of https://github.com/nens/rana/issues/4767
// Are fixed. This is because a guest in the tenant currently can't get any hcc models and schematisations.
// But this access should be filtered by if a model and its schema belong to a project the user has access to.
export const useCanSeeModelSchematisation = () => {
  const { canReadDatasetList } = useTenantActionAllowed();

  const modelSchematisationForCollaboratorsIsEnabled = useIsFeatureEnabled(
    "enableModelSchematisationForCollaborators"
  );

  if (modelSchematisationForCollaboratorsIsEnabled) {
    return true;
  }

  return canReadDatasetList;
};
